import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
// Styles
import styles from "./TimePicker.module.scss";

const TimePicker = ({ selectedDay, selectedTime, onSelectTime }) => {
  if (selectedDay === "Saturday") {
    return null;
  }

  return (
    <div className={styles.root}>
      <button
        type="button"
        className={cn(styles.timeButton, {
          [styles.active]: "8-11AM" === selectedTime,
        })}
        onClick={() => onSelectTime("8-11AM")}
      >
        Morning 8-11AM
      </button>

      <button
        type="button"
        className={cn(styles.timeButton, {
          [styles.active]: "11-2:30PM" === selectedTime,
        })}
        onClick={() => onSelectTime("11-2:30PM")}
      >
        Mid-day 11-2:30PM
      </button>

      <button
        type="button"
        className={cn(styles.timeButton, {
          [styles.active]: "2:30-5:30PM" === selectedTime,
        })}
        onClick={() => onSelectTime("2:30-5:30PM")}
      >
        Afternoon 2:30-5:30PM
      </button>
    </div>
  );
};

TimePicker.propTypes = {
  selectedDay: PropTypes.string,
  selectedTime: PropTypes.string,
  availableTimes: PropTypes.array,
  onSelectTime: PropTypes.func,
};

export default TimePicker;
